module.exports = __webpack_public_path__ + "static/media/student-end-season-side.5459b9e9.png";